/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import React from 'react';
import Link from 'next/link';

export const UnderscoreLink = ({
  text,
  href,
}: {
  text: string;
  href: string;
}) => {
  return (
    <Link
      href={href}
      target="_blank"
      className="text-body font-normal text-[#34BCAF] underline underline-offset-2"
    >
      {text}
    </Link>
  );
};
